import React from 'react';
import BottomNavMobile from '../Components/BottomNavMobile';
import './Main_mobile.css';

export default function MainMobile({ 
    patients, totalPatientsCount, searchTerm, setSearchTerm, loading, error, 
    isDatabaseEmpty, isSearchEmpty, onAddPatient, onPatientClick, onRefresh,
    sortOrder, setSortOrder, genderFilter, setGenderFilter, 
    cityFilter, setCityFilter, availableCities,
    showMobileFilter, setShowMobileFilter
}) {
    return (
        <div className="mobile-main-container" dir="rtl">
            <img src="/images/dna_pattern_blue.png" alt="watermark" className="mobile-main-watermark" />
            
            <div className="mobile-main-header">
                <span className="mobile-main-title">نظام إدارة الأوبئة<br/>الرئيسية</span>
                <i className={`fa-solid fa-rotate-right ${loading ? 'fa-spin' : ''}`} onClick={onRefresh} style={{ fontSize: '22px', color: '#0b67b1', cursor: 'pointer', padding: '10px' }}></i>
            </div>

            <div className="mobile-search-row">
                {/* زر فتح الفلاتر */}
                <div className="mobile-filter-btn" onClick={() => setShowMobileFilter(true)}>
                    <i className="fa-solid fa-sliders mobile-filter-icon"></i>
                    {/* نقطة حمراء كدليل على وجود فلتر مفعل */}
                    {(genderFilter !== 'all' || cityFilter !== 'all' || sortOrder !== 'newest') && <span className="filter-active-dot"></span>}
                </div>
                
                <div className="mobile-search-box">
                    <i className="fa-solid fa-magnifying-glass"></i>
                    <input 
                        type="text" 
                        placeholder="ابحث برقم وطني، اسم..." 
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>
            </div>

            {/* نافذة الفلاتر (Bottom Sheet) */}
            {showMobileFilter && (
                <>
                    <div className="mobile-filter-overlay" onClick={() => setShowMobileFilter(false)}></div>
                    <div className="mobile-filter-sheet">
                        <div className="sheet-header">
                            <h3>تصفية وترتيب المرضى</h3>
                            <i className="fa-solid fa-xmark" onClick={() => setShowMobileFilter(false)}></i>
                        </div>
                        
                        <div className="filter-group">
                            <label>الترتيب الزمني:</label>
                            <select value={sortOrder} onChange={(e) => setSortOrder(e.target.value)}>
                                <option value="newest">من الأحدث إلى الأقدم</option>
                                <option value="oldest">من الأقدم إلى الأحدث</option>
                            </select>
                        </div>

                        <div className="filter-group">
                            <label>الجنس:</label>
                            <select value={genderFilter} onChange={(e) => setGenderFilter(e.target.value)}>
                                <option value="all">الكل</option>
                                <option value="male">ذكر</option>
                                <option value="female">أنثى</option>
                            </select>
                        </div>

                        <div className="filter-group">
                            <label>المدينة:</label>
                            <select value={cityFilter} onChange={(e) => setCityFilter(e.target.value)}>
                                <option value="all">كل المدن</option>
                                {availableCities.map(city => (
                                    <option key={city} value={city}>{city}</option>
                                ))}
                            </select>
                        </div>

                        <button className="sheet-apply-btn" onClick={() => setShowMobileFilter(false)}>تطبيق وإغلاق</button>
                    </div>
                </>
            )}

            {/* عرض الحالات كما هي في كودك السابق مع تعديلات بسيطة */}
            {loading && totalPatientsCount === 0 ? (
                <div className="mobile-no-results"><h3>جاري تحميل البيانات...</h3></div>
            ) : error ? (
                <div className="mobile-no-results">
                    <h3 style={{color: 'red'}}>حدث خطأ في الاتصال</h3><p>{error}</p>
                </div>
            ) : isDatabaseEmpty ? (
                <div className="mobile-no-results" onClick={onAddPatient}>
                    <h3>لا يوجد مرضى في النظام</h3>
                    <p style={{ cursor: 'pointer', textDecoration: 'underline' }}>انقر هنا لإضافة مريضك الأول</p>
                </div>
            ) : isSearchEmpty ? (
                <div className="mobile-no-results">
                    <h3>لم يتم العثور على نتائج</h3>
                    <p>الرجاء تعديل كلمات البحث أو مسح الفلاتر</p>
                </div>
            ) : (
                <>
                    <h2 className="mobile-section-title">المرضى ({patients.length})</h2>
                    <div className="mobile-patients-list">
                        {patients.map((patient) => (
                            <div className="mobile-patient-card" key={patient.id} onClick={() => onPatientClick(patient.id)}>
                                <div className="mobile-patient-header">
                                    <h3 className="mobile-patient-name">{patient.name || 'اسم غير متوفر'}</h3>
                                    <div className="mobile-status-icon status-green"><i className="fa-solid fa-user"></i></div>
                                </div>
                                <div className="mobile-patient-details">
                                    <p>الرقم: {patient.national_number || 'غير متوفر'} | {patient.city || 'مدينة غير محددة'}</p>
                                    <p>الجنس: {patient.gender === 'male' ? 'ذكر' : patient.gender === 'female' ? 'أنثى' : 'غير محدد'}</p>
                                </div>
                                <div className="mobile-details-link"><span>عرض الملف</span><i className="fa-solid fa-chevron-left"></i></div>
                            </div>
                        ))}
                    </div>
                </>
            )}

            <button className="mobile-fab" onClick={onAddPatient}>+</button>
            <BottomNavMobile />
        </div>
    );
}